var React = require('react');

function HandPeace (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 256v80a40.36 40.36 0 0 1-1.06 9.16l-32 136A40 40 0 0 1 376 512H136a40 40 0 0 1-34.73-20.15l-64-112A40 40 0 0 1 47 328.77l31.1-24.88L3.34 113.55a48 48 0 1 1 89.35-35.1L162.43 256H176V48a48 48 0 0 1 96 0v208h8v-32a40 40 0 0 1 80 0v32h8a40 40 0 0 1 80 0z","className":"fa-secondary","key":1})]);
}

HandPeace.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = HandPeace;

HandPeace.default = HandPeace;
